export default __webpack_public_path__ + "static/media/zebra.f5584398.ogg";